import { render } from "./BaseFieldInput.vue?vue&type=template&id=7674d69b"
import script from "./BaseFieldInput.vue?vue&type=script&lang=js"
export * from "./BaseFieldInput.vue?vue&type=script&lang=js"

import exportComponent from "/builds/rclass/new_shlepakov/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__